/**
 * Guest shopping lists live in localStorage (store uses skipHydrate). During client
 * hydration the store can already contain items while SSR rendered an empty list, so
 * defer guest list-membership UI until after mount.
 */
export default function useHydrationSafeListMembership(amount: Ref<number>) {
	const {isAuthenticated} = useAuth();
	const isReady = ref(import.meta.server);

	onMounted(() => {
		isReady.value = true;
	});

	return computed(() => {
		if (!isReady.value && !isAuthenticated.value) {
			return false;
		}

		return amount.value > 0;
	});
}
